import { useEffect } from 'react';

import { useRequestWithPagination } from '../../../hooks/useRequestWithPagination';
import { AdminCourse, isCourseActive } from '../../../models/CourseModels';
import { useAdminApi } from '../Admin/hooks/useAdminApi';
import { useToast } from '../../../hooks/toast';

import CoursesTable from './components/CoursesTable';
import Button from '../../../components/Atoms/Button';
import Loading from '../../../components/Atoms/Loading';

import { Center, ListContainer } from '../../_layout/AdminLayout.styles';

const AdminCoursesInfos = () => {
  const {
    data,
    currentPage,
    maxPage,
    isLoading,
    isLastPage,
    setIsLoading,
    setData,
    setMaxPage,
    setCurrentPage,
  } = useRequestWithPagination<AdminCourse[]>([]);

  const { fetchCourses } = useAdminApi();
  const { addToast } = useToast();

  const showFetchMoreBtn = !!data.length && !isLastPage;

  const handleSelectItem = () => {};

  const showLoadError = () =>
    addToast({
      type: 'error',
      title: 'Erro ao carregar cursos',
      description: 'Não foi possível buscar a lista. Recarregue a página para tentar de novo.',
    });

  const fetchMore = async () => {
    const nextPage = currentPage + 1;
    if (nextPage > maxPage) {
      return;
    }

    setIsLoading(true);
    try {
      const newPayments = await fetchCourses(nextPage);
      setData(oldPayments =>
        oldPayments.concat((newPayments.data.courses ?? []).filter(isCourseActive)),
      );
      if (newPayments.data.pages !== maxPage) {
        setMaxPage(newPayments.data.pages);
      }
      setCurrentPage(nextPage);
    } catch {
      showLoadError();
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchCourses(0);

      setMaxPage(result.data.pages ?? 0);
      setData((result.data.courses ?? []).filter(isCourseActive));
    } catch {
      showLoadError();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ListContainer>
        {isLoading && data.length === 0 ? (
          <Center>
            <Loading />
          </Center>
        ) : (
          <>
            <CoursesTable
              data={data}
              currentIndex={currentPage}
              lastIndex={maxPage}
              onSelectItem={handleSelectItem}
            />
          </>
        )}
      </ListContainer>
      {showFetchMoreBtn && (
        <Button onClick={fetchMore} loading={isLoading}>
          Carregar mais ...
        </Button>
      )}
    </>
  );
};

export default AdminCoursesInfos;
